import Hat from "../images/Merch/Hat.png";
import '../css/Merch.css';
const Merch = () => {

    return (
        <div>
            <div className="hats-cont">
                <h2>Captain Hats Now Available! </h2>
                <p>Grab one at a show!</p>
                <img src={Hat} width={200} className="hat" alt="Dirty Yachtin Scoundrel Captain Hat" />
            </div>
        </div>
    )
}
export default Merch